<div class="content">
    <h1>404</h1>
</div>
